import React from 'react';
import { Button } from '~c/ui/Button';

export const SuccessReg = (props) => {
  const onClick = () => {
    window.location.assign('/profile/');
  };

  return (
    <React.Fragment>
      <div className="registration-success">
        <h4 className="heading heading--2 registration-success__title">
          {props.fillLater ? 'Вы успешно отправили заявку на обучение!' : 'Вы успешно зарегистрировались!' }
          </h4>
        <div className="registration-success__subtitle">
          <p>            
            {props.fillLater ? 'Для завершения регистрации Вам необходимо предоставить дополнительные данные. Заполните их в Личном кабинете в разделе "Профиль".' : 'На Вашу электронную почту, указанную при регистрации, будет направлено письмо-подтверждение.'}
          </p>
          <p>
            Благодарим за выбор программ Академии.
          </p>
        </div>
      </div>
      <div className="separate"></div>
      <div className="registration__btns">
        <Button onClick={onClick}>В личный кабинет</Button>
      </div>
    </React.Fragment>
  );
};

